import TechSupportModal from './TechSupportModal';
export default TechSupportModal;
